import { Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../shared/context/auth-context';
import menuItem from './style';
import './menuItems.css';

export default function HeaderMenu() {
  const { logout, deviceType } = useAuthContext();
  const location = useLocation();

  return (
    <Menu selectedKeys={location.pathname} mode="horizontal">
      <Menu.Item key="/" style={menuItem}>
        <Link to="/" />
        Οι διαδρομές μου
      </Menu.Item>
      <Menu.Item key="/guide" style={menuItem}>
        <Link to="/guide" />
        {deviceType === 'mobile'
          ? 'Οδηγίες Beacon συσκευής'
          : 'Οδηγίες OBD συσκευής'}
      </Menu.Item>
      <Menu.SubMenu key="/myprofile" title="Ο λογαριασμός μου">
        <Menu.Item key="/profile" style={menuItem}>
          <Link to="/profile" />
          Αλλαγή στοιχείων πρόσβασης
        </Menu.Item>
        <Menu.Item
          key="/logout"
          onClick={() => {
            logout();
          }}
          style={menuItem}
        >
          Αποσύνδεση
        </Menu.Item>
        <Menu.Item key="/deleteAccount" style={menuItem}>
          <Link to="/deleteAccount" />
          Διαγραφή λογαριασμού
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );
}
